import React from 'react';
import { useSticky } from '../hooks/useSticky';

export const hocWithSticky = (Component) => (props) => {
  const sticky = useSticky();
  return <Component {...props} sticky={sticky} />;
};
